'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ArrowForward = {};

exports.__exports = ArrowForward;
